import React, { useState, useEffect } from "react";
import "./css/Footer.css";
import Menu from '../menu/Menu';
import { Link } from "react-router-dom";
import { SmartCaptcha } from '@yandex/smart-captcha';

const Footer = () => {
  const [email, setEmail] = useState("");
  const [question, setQuestion] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [captchaToken, setCaptchaToken] = useState("");
  const [error, setError] = useState("");
  const [submitStatus, setSubmitStatus] = useState(null);
  const [isCaptchaCompleted, setIsCaptchaCompleted] = useState(false);

  // Эффект для проверки глобальных обработчиков
  useEffect(() => {
    const checkGlobalHandlers = () => {
      // Временно удаляем возможные глобальные обработчики
      const originalAddEventListener = document.addEventListener;
      document.addEventListener = function(type, listener, options) {
        if (type === 'keydown' || type === 'keyup' || type === 'keypress') {
          console.log('Global key handler added:', type, listener);
        }
        return originalAddEventListener.call(this, type, listener, options);
      };
    };

    checkGlobalHandlers();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };

  const handleFooterLinkClick = () => {
    scrollToTop();
  };

  const validateEmail = (email) => {
    if (!email.trim()) return 'Email обязателен для заполнения';
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return 'Введите корректный email адрес';
    }
    
    return '';
  };

  const handleInputChange = (field, value) => {
    if (field === 'email') {
      setEmail(value);
    } else if (field === 'question') {
      setQuestion(value);
    }

    if (error) {
      setError("");
    }
    if (submitStatus === 'error') {
      setSubmitStatus(null);
    }
  };

  // Специальный обработчик для textarea
  const handleQuestionChange = (e) => {
    const value = e.target.value;
    setQuestion(value);
    
    // Сбрасываем ошибки при вводе
    if (error) setError("");
    if (submitStatus === 'error') setSubmitStatus(null);
  };

  const handleCaptchaSuccess = (token) => {
    setCaptchaToken(token);
    setIsCaptchaCompleted(true);
  };

  const handleCaptchaError = () => {
    setCaptchaToken('');
    setIsCaptchaCompleted(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const emailError = validateEmail(email);
    if (emailError) {
      setError(emailError);
      setSubmitStatus('error');
      return;
    }

    if (!question.trim()) {
      setError("Заполните ваш вопрос");
      setSubmitStatus('error');
      return;
    }

    if (!captchaToken) {
      setError("Пожалуйста, подтвердите, что вы не робот");
      setSubmitStatus('error');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);
    setError("");

    try {
      const response = await fetch("/api/footer-question.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email.trim(),
          question: question.trim(),
          smart_token: captchaToken,
        }),
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.message || "Ошибка сервера");
      }

      setSubmitStatus('success');

    } catch (err) {
      console.error("Ошибка отправки вопроса:", err);
      setSubmitStatus('error');
      setError(err.message || "Не удалось отправить вопрос. Попробуйте позже.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const isSubmitDisabled = isSubmitting || !isCaptchaCompleted;

  return (
    <footer className="footer-wrapper">
      <div className="footer">
        <div className="footer-container">
          <div className="footer-top">
            <Menu dark={true} marginBottom={0} padding={0} />
          </div>

          <div className="footer-main">
            <div className="footer-column">
              <div className="footer-section">
                <h3 className="section-title">Контакты</h3>
                <div className="contact-info">
                  <div className="contact-item">
                    <div>
                      <p className="contact-label">Email</p>
                      <p className="contact-email">info@altcor.ru</p>
                    </div>
                  </div>
                  <div className="contact-item">
                    <div>
                      <p className="contact-label">Телефон</p>
                      <p className="contact-phone">+7 (495) 902-03-02</p>
                    </div>
                  </div>
                  <div className="contact-item">
                    <div>
                      <p className="contact-label">Время работы</p>
                      <p className="contact-time">Пн-Пт: 9:00–18:00</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="footer-column">
              <div className="footer-section">
                <h3 className="section-title-unset">ООО "АЛЬТКОР"</h3>
                <div className="company-details">
                  <div className="detail-item">
                    <span className="detail-label">Полное наименование</span>
                    <span className="detail-value">Общество с ограниченной ответственностью "Альткор"</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Адрес</span>
                    <span className="detail-value">107023, город Москва, Суворовская ул, д. 19 стр. 1, помещ. 17</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">ИНН</span>
                    <span className="detail-value">9718280720</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">КПП</span>
                    <span className="detail-value">771801001</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">ОГРН</span>
                    <span className="detail-value">1257700217246</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Основной ОКВЭД</span>
                    <span className="detail-value">62.01 – Разработка компьютерного программного обеспечения</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Коды видов деятельности в области ИТ</span>
                    <span className="detail-value">1.01, 2.01</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Реестр №</span>
                    <span className="detail-value">29212 от 20.08.2025</span>
                  </div>
                  <span className="detail-label">Исключительные права на ПЭВМ "Безопасный контур" принадлежат ООО "Альткор"</span>
                </div>
              </div>
            </div>

            <div className="footer-column">
              <div className="footer-section">
                {submitStatus !== 'success' ? (
                  <>
                    <h3 className="section-title-unset">Остались вопросы?</h3>
                    <p className="form-description">
                      Напишите нам, и мы ответим в течение часа
                    </p>

                    <form className="contact-form" onSubmit={handleSubmit} noValidate>
                      <div className="form-group">
                        <input
                          type="email"
                          placeholder="Ваш email *"
                          className="form-input"
                          value={email}
                          onChange={(e) => handleInputChange('email', e.target.value)}
                          required
                          disabled={isSubmitting}
                          onKeyDown={(e) => {
                            // Разрешаем все клавиши
                            e.stopPropagation();
                          }}
                        />
                      </div>

                      <div className="form-group">
                        <textarea
                          placeholder="Ваш вопрос... *"
                          className="form-textarea"
                          rows="4"
                          value={question}
                          onChange={handleQuestionChange}
                          onKeyDown={(e) => {
                            // Явно разрешаем пробел и другие клавиши
                            if (e.key === ' ') {
                              e.stopPropagation();
                              // Не вызываем preventDefault(), чтобы пробел обрабатывался нормально
                            }
                          }}
                          onKeyUp={(e) => {
                            e.stopPropagation();
                          }}
                          onKeyPress={(e) => {
                            e.stopPropagation();
                          }}
                          required
                          disabled={isSubmitting}
                          style={{ 
                            pointerEvents: 'auto',
                            userSelect: 'auto',
                            WebkitUserSelect: 'auto'
                          }}
                        />
                      </div>

                      <div className="form-group" style={{ margin: "0px 0" }}>
                        <SmartCaptcha
                          sitekey="ysc1_6XhhyAXuJbg3XWnmYw5tPWA4Y2YDcT3D69nxulpj38e128c7"
                          onSuccess={handleCaptchaSuccess}
                          onError={handleCaptchaError}
                          language="ru"
                          theme="dark"
                        />
                      </div>

                      {submitStatus === 'error' && (
                        <div className="footer-form-error">
                          <svg className="footer-error-icon" width="18" height="18" viewBox="0 0 24 24" fill="none">
                            <path d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" 
                              stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          {error}
                        </div>
                      )}

                      <button
                        type="submit"
                        className={`question-button ${isSubmitting ? "loading" : ""} ${isSubmitDisabled ? "question-button--disabled" : ""}`}
                        disabled={isSubmitDisabled}
                      >
                        {isSubmitting ? (
                          <>
                            <div className="spinner"></div>
                            Отправка...
                          </>
                        ) : (
                          <>
                            Отправить вопрос
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                              <path
                                d="M5 12H19M19 12L12 5M19 12L12 19"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </>
                        )}
                      </button>
                    </form>
                  </>
                ) : (
                  <div className="footer-success-message">
                    <div className="footer-success-icon">
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                        <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <h3 className="footer-success-title">Вопрос отправлен!</h3>
                    <p className="footer-success-text">
                      Мы ответим вам в течение часа на указанный email
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-divider"></div>
            <div className="footer-copyright">
              <p>© 2025 ООО "АЛЬТКОР". Все права защищены. </p>
              <div className="footer-links">
                <Link
                  to="https://cloud.altcor.ru/Инструкция_по_установке_и_эксплуатации_ПЭВМ_Безопасный_контур.pdf"
                  className="footer-link"
                  onClick={handleFooterLinkClick}
                >
                  Инструкция по установке и эксплуатации   
                </Link>
                <Link
                  to="https://cloud.altcor.ru/Описание_функциональных_хар_к_ПЭВМ_Безопасный_контур.pdf"
                  className="footer-link"
                  onClick={handleFooterLinkClick}
                >
                  Описание функциональных характеристик
                </Link>
                <Link
                  to="/privacy-policy"
                  className="footer-link"
                  onClick={handleFooterLinkClick}
                >
                  Политика конфиденциальности
                </Link>
                <Link
                  to="/terms-of-use"
                  className="footer-link"
                  onClick={handleFooterLinkClick}
                >
                  Пользовательское соглашение
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;